<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="材料项" prop="materialItemId">
        <a-input v-model="form.materialItemId" placeholder="请输入"  :maxLength="50" />
      </a-form-model-item>
            <a-form-model-item label="维修项SKU" prop="prodSkuId">
        <a-input v-model="form.prodSkuId" placeholder="请输入"  :maxLength="50" />
      </a-form-model-item>
       <a-form-model-item label="状态" prop="status">
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button :value="0"> 禁用 </a-radio-button>
          <a-radio-button :value="1"> 启用 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
       <a-form-model-item label="定价类型" prop="pricingType">
        <a-radio-group v-model="form.pricingType" button-style="solid">
          <a-radio-button :value="0"> 固定 </a-radio-button>
          <a-radio-button :value="1"> 自定义 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="服务价格" prop="price">
        <a-input v-model="form.price" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'.').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\d*\.\d{0,2}).*$/g,'$1')" :maxLength="50" />
      </a-form-model-item>
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'
import { getObj, addObj, putObj } from '@/api/repairModule/productMaterials'
import Editor from '@/components/Editor'
export default {
  name: 'CreateForm',
  components: {
    Editor,
  },
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        status: 1,
        materialItemId: undefined,
        price: 0,
        pricingType: 0,
        prodSkuId: undefined,
      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      rules: {
        code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
        name: [{ required: true, message: '请输入话术名称', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        scriptExplanation: [{ required: true, message: '请输入话术说明', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onClose() {
      this.open = false
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        status: 1,
        materialItemId: undefined,
        price: undefined,
        pricingType: 0,
        prodSkuId: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加维修产品项材料定价'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改维修产品项材料定价'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
